// O número da execução do app (o "boot") pra camada de sync (AP-116, review de
// 29/09/2026: o prazo de validade da entrada de OUTRA conta no outbox).
//
// O relógio da TV mente (sem RTC antes do NTP, resetado, adiantado: ver sync/clock.ts e
// a migração dos carimbos). Um prazo só por tempo apagaria em massa, num relógio
// adiantado, sobras recém-gravadas. Por isso o prazo exige tempo E boots, com um teto só
// de boots (o que termina mesmo com o relógio parado). Mesma forma do teto global da
// migração dos carimbos.
//
// Contado uma vez por execução, no primeiro uso, e persistido no localStorage. Sem
// localStorage (ou sem conseguir gravar), `null`: sem contagem de boots, o prazo não
// vence (o lado seguro: a sobra fica, como antes).

const KEY = 'iptv:sync-boot'

/** undefined = ainda não contado nesta execução; null = sem como contar. */
let thisBoot: number | null | undefined

/** O número desta execução do app (1, 2, 3...), ou null se não dá pra contar. */
export function currentSyncBoot(): number | null {
  if (thisBoot !== undefined) return thisBoot
  try {
    if (typeof localStorage === 'undefined') {
      thisBoot = null
      return thisBoot
    }
    const prev = Number(localStorage.getItem(KEY) ?? '0')
    const n = (Number.isFinite(prev) && prev >= 0 ? Math.floor(prev) : 0) + 1
    localStorage.setItem(KEY, String(n))
    // Read-back: um setItem que "não lança" mas não grava (quota) não conta boot.
    thisBoot = localStorage.getItem(KEY) === String(n) ? n : null
  } catch {
    thisBoot = null
  }
  return thisBoot
}
